import { Card, CardContent } from "@/components/ui/card";
export default function EjemplosDeExitoDeNuestrasOperacionesEnInversiones() {
  const successStories = [{
    id: 1,
    title: "Estrategia de Dividendos",
    description: "Nuestro estudiante logró construir un portafolio de dividendos que genera $2,500 mensuales en ingresos pasivos utilizando estrategias aprendidas en nuestros seminarios en vivo.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/dividend_strategy_success.png"
  }, {
    id: 2,
    title: "Trading de Opciones",
    description: "Alumno implementó técnicas de contratos de opciones que incrementaron su rentabilidad en un 43.56% durante una sola mañana.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/options_trading_success.png"
  }, {
    id: 3,
    title: "Análisis Técnico Efectivo",
    description: "Estudiante aplicó herramientas de análisis técnico para identificar puntos de entrada óptimos, logrando un 78% de operaciones exitosas.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/technical_analysis_success.png"
  }, {
    id: 4,
    title: "Crecimiento de Capital",
    description: "Estudiante alcanzó un crecimiento del 120% en su cuenta de inversión en 18 meses aplicando estrategias de growth stocks enseñadas en los seminarios en vivo.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/capital_growth_success.png"
  }, {
    id: 5,
    title: "Gestión de Riesgo",
    description: "Inversionista implementó técnicas de gestión de riesgo que protegieron su capital durante períodos de alta volatilidad, manteniendo ganancias constantes.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/risk_management_success.png"
  }, {
    id: 6,
    title: "ETF Diversificado",
    description: "Estudiante construyó un portafolio diversificado de ETFs que superó al S&P 500 por 8 puntos porcentuales en rendimiento anual.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/etf_diversification_success.png"
  }];
  return <section className="bg-background py-16 px-6 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-foreground mb-4">
          Ejemplos de Éxito de Nuestras Operaciones en Inversiones
        </h2>
        <p className="text-center text-muted-foreground text-lg mb-12 max-w-3xl mx-auto">
          Historias reales de estudiantes que han transformado su futuro financiero aplicando las estrategias aprendidas en Genesis Inversores.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {successStories.map((story, i) => <Card key={story.id} data-index={i} className="group overflow-hidden hover:-translate-y-2 transition-all duration-300 ease-out-back shadow-soft hover:shadow-medium border border-border">
              <div className="overflow-hidden">
                <img src={story.image} alt={story.title} className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {story.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {story.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}